import { OauthType } from "@/types/oauth/oauth";
import { decodeJWT } from "@/utils/string/decodeJwt";

export const logoutOath = async () => {
    await Promise.resolve(true);
}

const OAUTH = {
    google: '/auth/google',
    facebook: '/auth/facebook',
    twitter: '/auth/twitter',
} as const

export const loginSocialOath  = async (provider: OauthType) => {
    const selectProvider = OAUTH[provider] ?? null
    const urlProvider = import.meta.env.VITE_LOGIN_URL_PROVIDER ?? null;
    if (!selectProvider){
        throw new Error("Provider not found")
    }
    if (!urlProvider){
        throw new Error("urlProvider not found")
    }
    window.location.href = `${urlProvider}${selectProvider}`
}


export const isLoggedInOauth = async (jwt: string) => {
    if (!jwt){
        throw new Error("jwt not found")
    }
    const wallet =  await decodeJWT(jwt);
    return {
        userInfo: {
            publicAddress: String(wallet).toUpperCase()
        },
        magic_token: null
    }
}